import { AlphaAIcon } from './AlphaAIcon';

/**
 * author: GreenTurtwig
 * id 8A55BEB9-D57B-43DA-9905-7216E3EB7057
 * name alpha-a
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-a.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetAIcon = AlphaAIcon;
export default AlphabetAIcon